import React from 'react';
import { Button } from '@hpstellar/core/visId';
import { ChevronRight } from '@hpstellar/vis-icons';
import { formatGtmAttrs } from '@hpstellar/utils';
import { useGetProductPrice } from '../../../../../hooks/useProductPrice';
import useAddToCart from '../../../../../hooks/useAddToCart';
import { getPurchaseButtonProps } from '../../../../get-product-props';

const PurchaseButtonContainer = ({ product, analyticsData, options }) => {
    const priceObj = useGetProductPrice(product);
    const addToCart = useAddToCart(true);
    const { purchaseBtnProps } = getPurchaseButtonProps(
        product,
        priceObj,
        { addToCart },
        analyticsData,
        false,
        options
    );

    if (!purchaseBtnProps || !purchaseBtnProps.children) {
        return null;
    }
    const { gtmAction, ...restProps } = purchaseBtnProps;
    return <Button className="purchase-btn" {...restProps} {...formatGtmAttrs(gtmAction)} theme="dark" />;
};

export default ({ product, productLinkProps, analyticsData, options, isMobile }) => {
    const { btnProps = {}, gtmAction, ...linkProps } = productLinkProps || {};
    return (
        <div className="product-cta-container">
            {linkProps && btnProps?.children && !isMobile && (
                <Button
                    {...formatGtmAttrs(gtmAction)}
                    {...linkProps}
                    {...btnProps}
                    theme="dark"
                    endIcon={<ChevronRight size="s" />}
                    variation="tertiary"
                    className="visid-view-details-link"
                    noBg
                />
            )}
            <PurchaseButtonContainer product={product} analyticsData={analyticsData} options={options} />
        </div>
    );
};
